module.exports = __webpack_public_path__ + "static/img/a2.e2f56f7b.png";